export const EDIT_TOOL_ZOOM = 1;
export const EDIT_TOOL_CROP = 2;
export const EDIT_TOOL_ROTATE_CLOCKWISE = 3;
export const EDIT_TOOL_ROTATE_COUNTER_CLOCKWISE = 4;
export const EDIT_TOOL_FLIP_HORIZONTAL = 5;
export const EDIT_TOOL_FLIP_VERTICAL = 6;
export const EDIT_TOOL_TRIGGER_CANCEL = 'cancel';
export const EDIT_TOOL_TRIGGER_RESET = 'reset';
export const EDIT_TOOL_ICONS = {
    [EDIT_TOOL_ZOOM]: {
        name: 'zoom',
        svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_205_15)">
              <path
                  d="M98.861 93.363L74.4561 68.9587C80.5223 61.6638 84.177 52.2965 84.177 42.0898C84.177 18.8814 65.2961 0 42.0887 0C18.8808 0 -0.00012207 18.8814 -0.00012207 42.0898C-0.00012207 65.2967 18.8808 84.1766 42.0887 84.1766C52.2948 84.1766 61.6627 80.5224 68.9575 74.4562L93.3629 98.8611C94.1218 99.6205 95.1171 100 96.1119 100C97.1067 100 98.102 99.6205 98.8615 98.8611C100.38 97.3427 100.38 94.8814 98.861 93.363ZM7.77577 42.0898C7.77577 23.169 23.1684 7.77589 42.0887 7.77589C61.0085 7.77589 76.4006 23.169 76.4006 42.0898C76.4006 61.0091 61.0085 76.4007 42.0887 76.4007C23.1684 76.4007 7.77577 61.0091 7.77577 42.0898Z"
                  fill="#7D7E82"/>
            </g>
          </svg>`
    },
    [EDIT_TOOL_CROP]: {
        name: 'crop',
        svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.7778 72.2222V0H16.6667V16.6667H0V27.7778H16.6667V72.2222C16.6667 78.3333 21.6611 83.3333 27.7778 83.3333H72.2222V100H83.3333V83.3333H100V72.2222H27.7778ZM72.2222 66.6667H83.3333V27.7778C83.3333 21.6667 78.3389 16.6667 72.2222 16.6667H33.3333V27.7778H72.2222V66.6667Z"
                fill="#7D7E82"/>
          </svg>`
    },
    // [EDIT_TOOL_ROTATE_CLOCKWISE]: {
    //     name: 'rotate',
    //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <g clip-path="url(#clip0_205_17)">
    //           <path
    //               d="M3.85712 92.8572V50C3.85929 48.1063 4.61254 46.2907 5.95161 44.9517C7.29069 43.6126 9.10624 42.8594 11 42.8572H53.8571C55.7508 42.8594 57.5664 43.6126 58.9055 44.9517C60.2445 46.2907 60.9978 48.1063 61 50V92.8572C60.9978 94.7509 60.2445 96.5665 58.9055 97.9055C57.5664 99.2446 55.7508 99.9979 53.8571 100H11C9.10624 99.9979 7.29069 99.2446 5.95161 97.9055C4.61254 96.5665 3.85929 94.7509 3.85712 92.8572V92.8572Z"
    //               fill="#7D7E82"/>
    //           <path
    //               d="M57.4287 0L62.4644 5.03571L53.2501 14.2857H71.7144C78.3425 14.2931 84.6971 16.9294 89.3839 21.6162C94.0707 26.303 96.707 32.6576 96.7144 39.2857V57.1428H89.5715V39.2857C89.5661 34.5514 87.683 30.0125 84.3353 26.6648C80.9876 23.3171 76.4487 21.434 71.7144 21.4286H53.2501L62.4644 30.6786L57.4287 35.7143L39.5715 17.8571L57.4287 0Z"
    //               fill="#7D7E82"/>
    //         </g>
    //       </svg>`
    // },
    // [EDIT_TOOL_FLIP_HORIZONTAL]: {
    //     name: 'flip',
    //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <g clip-path="url(#clip0_205_18)">
    //           <path
    //               d="M37.8114 2.5941L0.313374 94.256C-0.808053 96.997 1.20805 100 4.16962 100H41.6677C43.9687 100 45.8341 98.1347 45.8341 95.8336V4.17156C45.8341 -0.397737 39.5414 -1.63517 37.8114 2.5941ZM37.5013 91.667H10.3757L37.5013 25.3601V91.667Z"
    //               fill="#7D7E82"/>
    //           <path
    //               d="M99.6871 94.2558L62.189 2.59396C60.459 -1.63512 54.1664 -0.397685 54.1664 4.17141V95.8333C54.1664 98.1343 56.0317 99.9997 58.3328 99.9997H95.8308C98.7924 99.9999 100.809 96.9969 99.6871 94.2558ZM62.4993 91.6669V25.36L89.6249 91.6669H62.4993V91.6669Z"
    //               fill="#7D7E82"/>
    //           <path d="M59.9989 95.9999V13.9999L93.9989 95.9999H59.9989Z" fill="#7D7E82" stroke="#7D7E82"/>
    //         </g>
    //       </svg>`
    // }
};
